import React from 'react';
import Mixpanel from 'helpers/Mixpanel.js';
import { AutoGrid, Grid } from '@bit/knotchinc.web-react-components.grid';
import { formatTime, formatterWithWord, numberWithCommas } from 'helpers/Utils.js';
import { REPORT_GRID_STYLE, findMaxItems, calculateRowHeight } from 'components/Pages/Reports/helpers.js';
import { ListTitle, Section } from 'components/Pages/Reports/styled.js';
import EntityListCard from 'components/Pages/Reports/EntityListCard.jsx';
import ReportLeaderboard from 'components/Pages/Reports/ReportLeaderboard/ReportLeaderboard.jsx';
import EntityBarChartTile from 'components/Tiles/EntityBarChartTile/EntityBarChartTile.jsx';
import ReportErrorTab from './ReportErrorTab.jsx';
import EntityLineChart from '../charts/EntityLineChart.jsx';

const ContentReportTab = ({
  report: {
    public_id,
    content: {
      entities_by_num_articles,
      entities_by_num_videos,
      entities_by_word_count,
      entities_by_reading_time,
      entities_timeseries,
      entities_by_num_contents,
      top_entities_by_num_contents,
      error,
    },
    entities,
  },
}) => {
  if (error) {
    return <ReportErrorTab error={error} />;
  }

  Mixpanel.track('viewed Content Report Tab', { report_id: public_id });
  const maxEntities = findMaxItems([entities_by_num_articles, entities_by_num_videos, entities_by_word_count, entities_by_reading_time]);
  const rowHeight = calculateRowHeight(maxEntities, 'content');

  const ContentCols = AutoGrid({
    rowHeight,
    cols: [
      <EntityListCard
        title="article"
        resources={entities_by_num_articles}
        unit="num_articles"
        formatter={numberWithCommas}
        type="content"
      />,
      <EntityListCard
        title="videos"
        resources={entities_by_num_videos}
        unit="num_videos"
        formatter={numberWithCommas}
        type="content"
      />,
      <EntityListCard
        title="Average word count"
        resources={entities_by_word_count}
        unit="avg_num_words"
        formatter={formatterWithWord('Words', numberWithCommas)}
        type="content"
      />,
      <EntityListCard
        title="Average reading time"
        resources={entities_by_reading_time}
        unit="avg_reading_time"
        formatter={formatTime}
        type="content"
      />,
    ],
    colsPerRow: 4,
    gridStyle: REPORT_GRID_STYLE,
  });

  return (
    <React.Fragment>
      <Section>
        <ListTitle>TOP CONTENT OVERVIEW</ListTitle>
        <ReportLeaderboard type="content" data={top_entities_by_num_contents} />
      </Section>
      <Section>
        <Grid gridStyle={REPORT_GRID_STYLE} height={500}>
          <ListTitle>CONTENT COMPARISON</ListTitle>
          <EntityBarChartTile data={entities_by_num_contents} />
        </Grid>
      </Section>
      <Section>
        <ContentCols />
      </Section>
      <Section>
        <Grid height={750} gridStyle={REPORT_GRID_STYLE}>
          <ListTitle>CONTENT OVER TIME</ListTitle>
          <EntityLineChart data={entities_timeseries} entities={entities} />
        </Grid>
      </Section>
    </React.Fragment>
  );
};

export default ContentReportTab;
